import { render, staticRenderFns } from "./ExEmployeePrimaryAssignmentWizard.vue?vue&type=template&id=9455fa80&scoped=true"
import script from "./ExEmployeePrimaryAssignmentWizard.vue?vue&type=script&lang=js"
export * from "./ExEmployeePrimaryAssignmentWizard.vue?vue&type=script&lang=js"
import style0 from "./ExEmployeePrimaryAssignmentWizard.vue?vue&type=style&index=0&id=9455fa80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9455fa80",
  null
  
)

export default component.exports